<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title v-ripple style="cursor: pointer" @click="fetchData()">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <span v-on="on">Faturas {{' '+invoiceOriginLabel}} {{shelved ? ' arquivadas' : ''}}</span>
                    </template>
                    <span>Clique para actualizar</span>
                </v-tooltip>
            </v-toolbar-title>
            <v-divider
                class="mx-2"
                inset
                vertical
            ></v-divider>
            <span style="font-size: 11px; color: grey; margin-top: 4px">
                {{selectedFetchDataOption !== fetchDataOption.NORMAL ? selectedFetchDataOption === fetchDataOption.CANCELED ? 'anuladas' : 'arquivadas' : ''}}
            </span>

            <v-spacer></v-spacer>

            <v-text-field class="mr-2 mb-2" fill-height
                  v-model="search"
                  append-icon="search"
                  :label="'procurar faturas '+invoiceOriginLabel.toLowerCase()+'...'"
                  clearable
                  single-line
                  hide-details
            ></v-text-field>

            <!--Filtrar por-->
            <div class="text-xs-center">
                <v-menu v-model="openFilterMenu"
                        :close-on-content-click="false"
                        offset-x
                        persistent>
                    <template v-slot:activator="{ on }">
                        <v-badge overlap small :color="filterInteraction ? 'success' : 'orange'">
                            <template v-slot:badge>
                                <span v-if="filteredFieldsAmount>0">{{filteredFieldsAmount}}</span>
                            </template>
                        <v-icon color="success" v-on="on" style="margin-top: 10px; margin-left: 10px" v-ripple>list</v-icon>
                        </v-badge>
                    </template>

                    <v-card>
                        <v-list>
                            <v-list-tile>
                                <v-list-tile-title>Filtros</v-list-tile-title>
                            </v-list-tile>
                        </v-list>

                        <v-divider></v-divider>

                        <v-list>
                            <v-layout wrap justify-center style="max-width: 450px; padding: 10px;">
                                <v-flex xs12 px-2>
                                    <v-select
                                        v-model="filterDocumentType"
                                        :items="docTypes"
                                        item-text="name"
                                        item-value="id"
                                        clearable
                                        label="Tipo Documento"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md6 px-2>
                                    <v-select
                                        v-model="filterArticleCategory"
                                        :items="articlesCategory"
                                        item-text="name"
                                        item-value="id"
                                        clearable
                                        label="Categoria(artigos)"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md6 px-2>
                                    <v-select
                                        v-model="filterArticleSubcategory"
                                        :items="articlesSubcategory"
                                        item-text="name"
                                        item-value="id"
                                        clearable
                                        label="Subcategoria(artigos)"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md6 px-2>
                                    <v-select
                                        v-model="filterClientCategory"
                                        :items="clientsCategory"
                                        item-text="name"
                                        item-value="id"
                                        clearable
                                        label="Categoria(clientes)"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md6 px-2>
                                    <v-select
                                        v-model="filterClientSubcategory"
                                        :items="clientsSubcategory"
                                        item-text="name"
                                        item-value="id"
                                        clearable
                                        label="Subcategoria(clientes)"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 px-2>
                                    <v-text-field
                                        v-model.number="filterPendentValueBegin"
                                        type="number"
                                        clearable
                                        min="0"
                                        label="Val. Pendente Min."></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 px-2>
                                    <v-text-field
                                        v-model.number="filterPendentValueEnd"
                                        type="number"
                                        clearable
                                        min="0"
                                        label="Val. Pendente Max."></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 px-2>
                                    <v-text-field
                                        v-model.number="filterTotalValueBegin"
                                        type="number"
                                        clearable
                                        min="0"
                                        label="Val. Total Min."></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 px-2>
                                    <v-text-field
                                        v-model.number="filterTotalValueEnd"
                                        type="number"
                                        clearable
                                        min="0"
                                        label="Val. Total Max."></v-text-field>
                                </v-flex>
                                <v-flex xs12 md6 px-2>
                                    <v-menu
                                        ref="filterBeginDateMenu"
                                        v-model="filterBeginDateMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                :value="computedFilterBeginDate"
                                                label="Emissão Min."
                                                prepend-icon="event"
                                                clearable
                                                @click:clear="filterBeginDate = ''"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker locale="pt" v-model="filterBeginDate" no-title @input="filterBeginDateMenu = false"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex xs12 md6 px-2>
                                    <v-menu
                                        ref="filterEndDateMenu"
                                        v-model="filterEndDateMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                :value="computedFilterEndDate"
                                                label="Emissão Max."
                                                prepend-icon="event"
                                                clearable
                                                @click:clear="filterEndDate = ''"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker locale="pt" v-model="filterEndDate" no-title @input="filterEndDateMenu = false"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex xs12 md6 px-2>
                                    <v-menu
                                        ref="filterBeginDueDateMenu"
                                        v-model="filterBeginDueDateMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                :value="computedFilterBeginDueDate"
                                                label="Vencimento Min."
                                                prepend-icon="event"
                                                clearable
                                                @click:clear="filterBeginDueDate = ''"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker locale="pt" v-model="filterBeginDueDate" no-title @input="filterBeginDueDateMenu = false"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex xs12 md6 px-2>
                                    <v-menu
                                        ref="filterEndDueDateMenu"
                                        v-model="filterEndDueDateMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                :value="computedFilterEndDueDate"
                                                label="Vencimento Max."
                                                prepend-icon="event"
                                                clearable
                                                @click:clear="filterEndDueDate = ''"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker locale="pt" v-model="filterEndDueDate" no-title @input="filterEndDueDateMenu = false"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>
                        </v-list>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn flat @click="clearFilterFields()">Cancelar</v-btn>
                            <v-btn color="primary" flat @click="fetchData()">Filtrar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </div>

            <!--invoice-->
            <invoice-form-modal
                :paymentMethods="paymentMethods"
                :invoice_types="invoice_types"
                :active_states="active_states"
            ></invoice-form-modal>

            <!--InvoiceReceipt paper-->
            <invoice-receipt-form-modal
            
            ></invoice-receipt-form-modal>

        </v-toolbar>

        <!--Data table-->
        <v-data-table xs12 sm6 md4
            :headers="headers"
            :items="invoices"
            :loading="loading"
            class="elevation-1"
            :no-data-text="noDataText()"
            :rows-per-page-items="Global.ROWS_PER_PAGE"
            :pagination.sync="pagination"
            hide-actions
            no-results-text="nenhum resultado"
            rows-per-page-text="por página"
            disable-initial-sort
        >
            <v-progress-linear v-slot:progress color="indigo" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.code ? getInvoiceCode(props.item) : 'Fatura programada' }}</td>
                <td class="text-xs-left">{{ props.item.document_type ? props.item.document_type.name : '---'}}</td>
                <td class="text-xs-left">{{ getClientProviderName(props.item)}}</td>
                <td class="text-xs-left">{{ props.item.sell.code+'/'+props.item.sell.series}}</td>
                <td class="text-xs-right">{{ props.item.emission_date | formatDate}}</td>
                <td class="text-xs-right" :style="[isInvoicePaymentLate(props.item) ? {'color': 'red'} : {'color':''}]" >{{ props.item.due_date | formatDate}}</td>
                <td class="text-xs-right">{{ props.item.pendent_value | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                <td class="text-xs-right">{{ props.item.total_value | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                <td class="justify-center layout px-0">
                    <v-icon v-ripple class="mr-2" small @click.stop="showItem(props.item)">open_in_new</v-icon>
                    <v-icon v-ripple v-if="!props.item.code && props.item.types_operation_type_id !== Types.operation_type.ANULADO" small class="mr-2" @click.stop="openEditDate(props.item, props.index)">calendar_today</v-icon>
                    <!--<v-icon v-if="!shelved" small class="mr-2" @click="shelveItem(props.item)">block</v-icon>-->
                    <!--<v-icon v-if="shelved" small class="mr-2" @click="restoreTrashedItem(props.item)">replay</v-icon>-->
                </td>
            </template>

            <template v-slot:footer>
                <td :colspan="headers.length">
                    <custom-pagination
                        :totalData="totalData"
                        @onPaginationChange="paginationChangeCallBack($event)"
                        :disabled="loading"
                    ></custom-pagination>
                </td>
            </template>

            <template v-if="error_fetching" slot="no-data">
                <v-btn flat color="primary" @click.stop="fetchData(shelved)"><v-icon>refresh</v-icon></v-btn>
                <span class="text-xs-center">nenhum dado encontrado</span>
            </template>
        </v-data-table>

        <!--Confirmation Dialog-->
        <v-dialog persistent max-width="290" v-model="openConfirmationDialog" @close="openConfirmationDialog = false">
            <v-card>
                <!--<v-card-title class="headline">Use Google's location service?</v-card-title>-->
                <v-card-text class="text-xs-center">
                    <p v-if="confirmationModalOp === 1">Tens a certeza que queres eliminar <br> <b>{{selectedInvoice.code+'/'+selectedInvoice.series}}</b>?</p>
                    <p v-if="confirmationModalOp === 2">Tens a certeza que queres <br> <span class="green--text text--darken-2">restaurar</span> <br><b>{{selectedInvoice.code}}</b>?</p>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div v-if="!loading_modal">
                        <v-btn color="red darken-1" flat @click.stop="confirmationDialogYes">Sim</v-btn>
                        <v-btn color="grey darken-1" flat @click.stop="close">Não</v-btn>
                    </div>
                    <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Totals-->
        <v-card style="margin-top: 10px; margin-bottom: 5px">
            <v-card-text >
                <v-layout wrap v-if="invoices.length > 0" class="text-xs-left">
                    <v-flex shrink style="margin-right: 25px">
                        <span style="font-weight: bold; color: #919191">Total Recebido: </span>
                        <span style="color: #388E3C">{{filteredTotalReceived | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</span>
                    </v-flex>
                    <v-flex shrink style="margin-right: 25px">
                        <span style="font-weight: bold; color: #919191">Total Pendente sem atraso: </span>
                        <span style="color: #F57C00;">{{filteredTotalPendent | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</span>
                    </v-flex>
                    <v-flex shrink style="margin-right: 25px">
                        <span style="font-weight: bold; color: #919191">Total Pendente em atraso: </span>
                        <span style="color: #D32F2F">{{filteredTotalPendentLate | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</span>
                    </v-flex>
                    <v-flex shrink>
                        <span style="font-weight: bold; color: #919191">Total: </span>
                        <span style="font-weight: bold; color: #616161;">{{filteredTotal | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</span>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>

        <!--Buttons-->
        <v-btn :outline="selectedFetchDataOption !== fetchDataOption.NORMAL" @click="fetchData(fetchDataOption.NORMAL)" dark small color='indigo' style="margin-left: 0; margin-right: 5px">
            Faturas
        </v-btn>
        <v-btn :outline="selectedFetchDataOption !== fetchDataOption.SHELVED"  @click="fetchData(fetchDataOption.SHELVED)" dark small color="grey darken-1" style="margin-left: 0; margin-right: 5px">
            Faturas arquivadas
        </v-btn>
        <v-btn :outline="selectedFetchDataOption !== fetchDataOption.CANCELED"  @click="fetchData(fetchDataOption.CANCELED)" dark small color='red' style="margin-left: 0; margin-right: 5px">
            Faturas anuladas
        </v-btn>

        <!--ScheduledInvoice-->
        <scheduled-invoice 
            :selectedInvoiceIndex="selectedInvoiceIndex"
            @onScheduledInvoiceDone="fetchData()"
        ></scheduled-invoice>


    </div>
</template>

<script>
    /* eslint-disable */
    import Vue from 'vue';
    import {Types, Global} from "../../config";
    import {mapGetters} from 'vuex';
    import ScheduledInvoice from '../invoice/ScheduledInvoice';
    import {eventBus} from "../../main";
    import {InvoiceOrigin} from "../../config";
    import CustomPagination from '../extra/CustomPagination.vue';
    import moment from 'moment';

    export default {
        created () {
            this.onShelveUnshelve();
            let vm = this;
            this.onInvoiceAddedOrEdited(vm);
            this.onReceiptDeletedUpdateInvoice(vm);
            this.onCancelingInvoice(vm);
        },

        beforeDestroy(){
            eventBus.$off('onInvoiceAdded');
            eventBus.$off('onReceiptDeletedUpdateInvoice');
            eventBus.$off('onCancelingInvoice');
            this.close();
        },

        data(){
            return {
                Global,
                Types,
                loading: false, //loading for list of invoices in the datatable
                loading_modal: false, //loading for the action buttons in form modal
                error_fetching: false,  //error for fetching list of invoices in the datatable
                search: '', //search for the datatable
                openConfirmationDialog: false, //loads confirmation modal with yes or no

                articlesCategory: [],
                articlesSubcategory: [],
                clientsCategory: [],
                clientsSubcategory: [],
                pagination: {},
                totalData: 0,

                //filter
                openFilterMenu: false,
                filterBeginDateMenu: false,
                filterEndDateMenu: false,
                filterBeginDueDateMenu: false,
                filterEndDueDateMenu: false,
                filterDocumentType: '',
                filterPendentValueBegin: '',
                filterPendentValueEnd: '',
                filterTotalValueBegin: '',
                filterTotalValueEnd: '',
                filterArticleCategory: '',
                filterArticleSubcategory: '',
                filterClientCategory: '',
                filterClientSubcategory: '',
                filterBeginDate: '',
                filterEndDate: '',
                filterBeginDueDate: '',
                filterEndDueDate: '',
                filterInteraction: false,
                filteredTotal: '',
                filteredTotalPendent: '',
                filteredTotalPendentLate: '',
                filteredTotalReceived: '',


                fetchDataOption: {
                    NORMAL: 0,
                    SHELVED: 1,
                    CANCELED: 2
                },
                selectedFetchDataOption: 0,

                headers: [
                    {text: 'Código Fatura', align: 'left', value: 'code'},
                    {text: 'Documento', value: 'document_type.name'},
                    {text: this.invoiceOriginLabel, align: 'left', value: 'sell.client.name', sortable: true},
                    {text: 'Venda', align: 'left', value: 'sell.id'},
                    {text: 'Data emissão', align: 'right', value: 'emission_date'},
                    {text: 'Data vencimento', align: 'right', value: 'due_date'},
                    {text: 'Pendente', align: 'right', value: 'pendent_value'},
                    {text: 'Total', align: 'right', value: 'total_value'},
                    {text: 'Ações', align: 'right', value: '', sortable: false}
                ],

                invoices: [],
                invoice_types: [],
                paymentMethods: [],
                docTypes: [
                    {id: 1, name: 'Fatura'},
                    {id: 2, name: 'Fatura/Recibo'},
                    {id: 3, name: 'Fatura Programada'}
                ],

                active_states: [{id: 0, name: 'inativo'}, {id: 1, name: 'ativo'}],
                selectedIndex: -1, //the index of the selected client, useful for shelve, add, update, restore
                shelved: false, //displays only shelved items or not
                confirmationModalOp: 0, //used for getting the confirmation actions (shelve, restore)
                selectedInvoiceIndex: -1,

            }

        },

        components: {
            ScheduledInvoice,
            CustomPagination,
        },

        props:{
            invoiceOrigin: Number,
            invoiceOriginLabel: String,
        },

        watch: {  
            pagination(){
                this.fetchData();
            },
            search() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.fetchData();
                }, 800);
            },
        },

        computed: {
            ...mapGetters([
                'getNewCompany',
                'getToken'
            ]),
            showInvoiceModal: {
                get(){
                    return this.$store.getters.getShowInvoiceModal;
                },
                set(value){
                    this.$store.dispatch('setShowInvoiceModal', value);
                }
            },
            showInvoiceReceiptModal: {
                get(){
                    return this.$store.getters.getShowInvoiceReceiptPaperModal;
                },
                set(value){
                    this.$store.dispatch('setShowInvoiceReceiptPaperModal', value);
                }
            },
            selectedCompany: {
                get(){
                    return this.$store.getters.getSelectedCompany;
                },
                set(value){
                    this.$store.dispatch('setSelectedCompany', value);
                }
            },
            selectedInvoice: {
                get(){
                    return this.$store.getters.getSelectedInvoice;
                },
                set(value){
                    this.$store.dispatch('setSelectedInvoice', value);
                }
            },
            showScheduledInvoice: {
                get(){
                    return this.$store.getters.getShowScheduledInvoice;
                },
                set(value){
                    this.$store.dispatch('setShowScheduledInvoice', value)
                }
            },
            openInvoiceFilterDialog: {
                get(){
                    return this.$store.getters.getOpenInvoiceFilterDialog;
                },
                set(value){
                    this.$store.dispatch('setOpenInvoiceFilterDialog', value)
                },
            },
            computedFilterBeginDate:{
                get(){
                    return this.filterBeginDate ? moment(this.filterBeginDate).format('DD-MM-YYYY') : '';
                },
                set(value){
                    this.filterBeginDate = new Date(value).toISOString().substr(0, 10);
                }
            },
            computedFilterEndDate:{
                get(){
                    return this.filterEndDate ? moment(this.filterEndDate).format('DD-MM-YYYY') : '';
                },
                set(value){
                    this.filterEndDate = new Date(value).toISOString().substr(0, 10);
                }
            },
            computedFilterBeginDueDate:{
                get(){
                    return this.filterBeginDueDate ? moment(this.filterBeginDueDate).format('DD-MM-YYYY') : '';
                },
                set(value){
                    this.filterBeginDueDate = new Date(value).toISOString().substr(0, 10);
                }
            },
            computedFilterEndDueDate:{
                get(){
                    return this.filterEndDueDate ? moment(this.filterEndDueDate).format('DD-MM-YYYY') : '';
                },
                set(value){
                    this.filterEndDueDate = new Date(value).toISOString().substr(0, 10);
                }
            },

            filteredFieldsAmount(){
                let count = 0;
                this.filterInteraction = false;

                if(this.filterDocumentType) count++;
                if(this.filterArticleCategory) count++;
                if(this.filterArticleSubcategory) count++;
                if(this.filterClientCategory) count++;
                if(this.filterClientSubcategory) count++;
                if(this.filterBeginDate) count++;
                if(this.filterEndDate) count++;
                if(this.filterBeginDueDate) count++;
                if(this.filterEndDueDate) count++;
                if(this.filterPendentValueBegin) count++;
                if(this.filterPendentValueEnd) count++;
                if(this.filterTotalValueBegin) count++;
                if(this.filterTotalValueEnd) count++;

                return count;
            }
        },

        methods: {

            paginationChangeCallBack(payload){
                this.pagination.rowsPerPage = payload.byPage;
                this.pagination.page = payload.currentPage;
                this.fetchData();
            },

            getClientProviderName(item){
                return this.invoiceOrigin === InvoiceOrigin.PurchaseInvoices ? item.purchase.provider.name :
                    this.invoiceOrigin === InvoiceOrigin.SellInvoices ? item.sell.client.name : '';
            },

            formatDate(date){
                if(!date) return null;

                const [year, month, day] = date.split('-');
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },

            noDataText(){
                return this.loading ? 'a carregar faturas ...' : 'nenhuma fatura.';
            },

            getDocumentTypeName(invoice){
               switch (invoice.types_document_id) {
                   case Types.document_type.FACTURA:
                       return "Fatura";
                   case Types.document_type.FACTURA_RECIBO:
                       return "Fatura/Recibo";
                   case Types.document_type.NOTA_DEBITO:
                       return "Nota de Débito";
                   case Types.document_type.NOTA_CREDITO:
                       return "Nota de Crédito";
               }
            },

            getInvoiceCode(invoice){
                return invoice.code+'/'+invoice.series;
            },

            fetchData(option = this.fetchDataOption.NORMAL){
                if(this.loading) return;
                this.selectedFetchDataOption = option;
                this.openFilterMenu = false;
                this.filterInteraction = true;
                try{
                    let url = '';

                    if(this.invoiceOrigin === InvoiceOrigin.PurchaseInvoices){
                        url = 'invoice/purchasesInvoices/'+this.selectedFetchDataOption;
                    }else if(this.invoiceOrigin === InvoiceOrigin.SellInvoices){
                        url = 'invoice/sellsInvoices/'+this.selectedFetchDataOption;
                    }

                    this.invoices = [];
                    this.loading = true;
                    this.error_fetching = false;

                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.get(url, { params : {
                        docType: this.filterDocumentType,
                        clientCat: this.filterClientCategory,
                        clientSubCat: this.filterClientSubcategory,
                        articleCat: this.filterArticleCategory,
                        articleSubcat: this.filterArticleSubcategory,
                        beginDate: this.filterBeginDate,
                        endDate: this.filterEndDate,
                        beginDueDate: this.filterBeginDueDate,
                        endDueDate: this.filterEndDueDate,
                        pendentValBegin: this.filterPendentValueBegin,
                        pendentValEnd: this.filterPendentValueEnd,
                        totalValBegin: this.filterTotalValueBegin,
                        totalValEnd: this.filterTotalValueEnd,
                        
                        pag_size: this.pagination.rowsPerPage,
                        pag_current: this.pagination.page,
                        sort_field: this.getSortBy(this.pagination),
                        sort_order: this.getSortDes(this.pagination),
                        search: this.search,
                    }
                })
                .then(response => {
                    this.consoleLog(response);
                    if(!response.data.success){
                        this.loading = false;
                        this.error_fetching = true;
                        this.handleErrorCodeMessage(response.data);
                        return;
                    }

                    try{
                        this.invoices = response.data.response.invoices;
                        this.paymentMethods = response.data.response.paymentMethods;
                        this.articlesCategory = response.data.response.articleCategory;
                        this.articlesSubcategory = response.data.response.articleSubcategory;
                        this.clientsCategory = response.data.response.clientsCategory;
                        this.clientsSubcategory = response.data.response.clientsSubcategory;

                        this.totalData = response.data.response.total_data;
                    }catch (e) { /*Do nothing*/ }
                    // this.invoice_types = response.data.response.invoiceOrigins;

                    // this.consoleLog(response);
                    this.totalRows = this.invoices.length;
                    this.loading = false;
                    this.calculateTotals();
                }).catch(error => {
                    this.consoleLog(error);
                    this.loading = false;
                    this.error_fetching = true;
                    this.showSnackBar('Erro ao carregar faturas!!!', 'error');
                });
                }catch (e) {
                    this.consoleLog(e);
                    this.showSnackBar('Ocorreu um erro ao carregar lista de faturas!', 'error');
                    this.loading_modal = false;
                }
            },

            calculateTotals(){
                let fTotal = 0;
                let fTotalPendent = 0;
                let fTotalPendentLate = 0;
                let fTotalReceived = 0;

                for (let i = 0; i < this.invoices.length; i++) {
                    let $invoice = this.invoices[i];
                    if(!$invoice.code){ //Checking if invoice is scheduled
                        // this.consoleLog('>>>>>>>>NoCode>>>>>>>>: '+$invoice);
                        continue;
                    }
                    // this.consoleLog('>>>>>>>>Index>>>>>>>>: '+i);
                    fTotal += $invoice.total_value;
                    fTotalReceived += ($invoice.total_value - $invoice.pendent_value);
                    if(this.isInvoicePaymentLate($invoice) > 0){
                        fTotalPendentLate += $invoice.pendent_value;
                    }else if($invoice.pendent_value > 0){
                        fTotalPendent += $invoice.pendent_value;
                    }
                }

                this.filteredTotal = fTotal;
                this.filteredTotalPendent = fTotalPendent;
                this.filteredTotalPendentLate = fTotalPendentLate;
                this.filteredTotalReceived = fTotalReceived;
            },

            isInvoicePaymentLate($invoice){
                return moment().diff($invoice.due_date, 'days') > 0 && $invoice.pendent_value > 0;
            },

            onShelveUnshelve(){
                let vm = this;
                eventBus.$on('onShelveUnshelve', function (shelved, invoice) {
                    if(shelved){
                        vm.invoices.splice(invoice, 1);
                    }
                })
            },

            shelve(){
                try{
                    this.loading_modal = true;
                    let name = this.selectedInvoice.code;

                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.delete('invoice/'+this.selectedInvoice.id)
                    .then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        this.invoices.splice(this.selectedIndex, 1);
                        this.showSnackBar(name+' removido com sucesso', 'success');
                    }).catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('Ocorreu um erro ao remover fatura', 'error');
                    }).finally( ()=>{
                        this.loading_modal = false;
                        this.openConfirmationDialog = false;
                        this.selectedInvoice = null;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao remover empresa!', 'error');
                    this.loading_modal = false;
                }
            },

            restoreTrashed(){
                try{
                    this.loading_modal = true;
                    let name = this.selectedInvoice.code;

                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.put('invoice/trashed/restore/'+this.selectedInvoice.id)
                    .then(response => {
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            this.loading_modal = false;
                            return;
                        }
                        this.invoices.splice(this.selectedIndex, 1);

                        this.selectedIndex = -1;
                        this.showSnackBar(name+' restaurado com sucesso', 'success');
                    }).catch(error => {
                        // this.consoleLog(error);
                        this.selectedIndex = -1;
                        this.showSnackBar('Ocorreu um erro ao restaurar fatura', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                        this.openConfirmationDialog = false;
                        this.selectedInvoice = null;
                    });
                }catch (e) {
                    this.loading_modal = false;
                    this.showSnackBar('Ocorreu um erro ao restaurar fatura', 'error');
                }
            },

            onInvoiceAddedOrEdited(vm){
                eventBus.$on('onInvoiceAdded', function(invoice){
                    try{
                        if(vm.selectedInvoice.id > 0){
                            vm.invoices.splice(vm.selectedIndex, 1, invoice);
                            vm.showSnackBar(invoice.code+' atualizado com sucesso', 'success');
                        }else{
                            vm.invoices.unshift(invoice);
                            vm.showSnackBar(invoice.code+' adicionado com sucesso', 'success');
                        }
                        vm.close();
                    }catch (e) {
                        this.consoleLog(e);
                        vm.showSnackBar('Ocorreu um erro ao adicionar empresa', 'error');
                    }
                })
            },

            showItem(item){
                this.selectedIndex = this.invoices.indexOf(item);
                this.selectedInvoice = item;

                this.consoleLog('selected invoice');
                this.consoleLog(this.selectedInvoice);

                switch (this.selectedInvoice.types_document_id) {
                    case Types.document_type.FACTURA_RECIBO:
                        this.showInvoiceReceiptPaper();
                        break;
                    case Types.document_type.FACTURA:
                        this.showInvoicePaper();
                        break;
                }
            },

            onReceiptDeletedUpdateInvoice(vm){
                eventBus.$on('onReceiptDeletedUpdateInvoice', function(invoicesResponse){
                    vm.consoleLog(invoicesResponse);
                    for(let i=0; i<vm.invoices.length; i++){
                        for(let j=0; j<invoicesResponse.length; j++) {
                            if (vm.invoices[i].id === invoicesResponse[j].id){
                                vm.invoices[i].pendent_value = invoicesResponse[j].pendent_value;
                            }
                        }
                    }
                });
            },

            onCancelingInvoice(vm){
                eventBus.$on('onCancelingInvoice', function(invoice, invoiceName){

                    let mIndex = -1;
                    for(let i=0; i<vm.invoices.length; i++){
                        if(vm.invoices[i].id === invoice.id){
                            mIndex = i;
                            break;
                        }
                    }
                    let inv = vm.invoices[mIndex];
                    inv.types_operation_type_id = invoice.types_operation_type_id;

                    // let invoiceStr = invoice.types_document_type_id === Types.document_type.FACTURA ? 'Fatura' : 'Fatura/Recibo';

                    if(mIndex > -1) vm.invoices.splice(mIndex, 1); else vm.consoleLog('index not found');
                    vm.showSnackBar(invoiceName+' '+vm.selectedInvoice.code+'/'+vm.selectedInvoice.series+' foi anulado com sucesso', 'success');
                })
            },

            openEditDate(item, index){
                this.consoleLog('edit dates');
                this.showScheduledInvoice = true;
                this.selectedInvoice = item;
                eventBus.$emit('onScheculedInvoiceOpened');
            },

            clearFilterFields(){
                this.filterDocumentType = '';
                this.filterArticleCategory = '';
                this.filterArticleSubcategory = '';
                this.filterClientCategory = '';
                this.filterClientSubcategory = '';
                this.filterBeginDate = null;
                this.filterEndDate = null;
                this.filterBeginDueDate = null;
                this.filterEndDueDate = null;
                this.filterPendentValueBegin = '';
                this.filterPendentValueEnd = '';
                this.filterTotalValueBegin = '';
                this.filterTotalValueEnd = '';
                // this.computedFilterBeginDate = '';
                // this.computedFilterEndDate = '';
                this.openFilterMenu = false;

                this.filterInteraction = true;
                // if(this.filteredFieldsAmount > 0)
                    this.fetchData();
            },

            showInvoicePaper(){
                // this.consoleLog('opening InvoicePaper');
                // eventBus.$emit('onInvoiceFormOpened', true);
                this.showInvoiceModal = true;
            },

            showInvoiceReceiptPaper(){
                this.showInvoiceReceiptModal = true;

            },

            shelveItem (item) {
                this.confirmationModalOp = 1;
                this.selectedIndex = this.invoices.indexOf(item);
                this.selectedInvoice = item;
                this.openConfirmationDialog = true;
            },

            restoreTrashedItem (item){
                this.confirmationModalOp = 2;
                this.selectedIndex = this.invoices.indexOf(item);
                this.selectedInvoice = item;
                this.openConfirmationDialog = true;
            },

            close () {
                this.showInvoiceModal = false;
                this.showInvoiceReceiptModal = false;
                this.openConfirmationDialog = false;
                this.loading = false;
                if(this.$v) this.$v.$reset();
                let vm = this;
                setTimeout(() => {
                    vm.selectedInvoice = null;
                    vm.selectedIndex = -1
                }, 300)
            },

            confirmationDialogYes(){
                if(this.confirmationModalOp === 1){
                    this.shelve();
                }else if(this.confirmationModalOp === 2){
                    this.restoreTrashed();
                }
            }
        },

    }
</script>

<style scoped>

</style>